<template>
  <div class="fip-mentions">
    <span
      :data-wptv="mentions">
      {{ mentions }}
    </span>
  </div>
</template>

<script>
import COUNTRIES from './countries.js'
import _get from 'lodash/get'
import formationDuration from '../../../../plugins/filters/formatDuration/formatDuration.filter'
import capitalizeFLetter from '../../../../plugins/filters/capitalizeFLetter/capitalizeFLetter.filter'

export default {
  name: 'FipMentions',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data () {
    const countries = _get(this.item, 'productionCountries', []).map(country => COUNTRIES[country])
    const itemDuration = this.item.duration ? formationDuration(this.item.duration) : ''

    return {
      mentions: [
        _get(this.item, 'genres[0]'),
        _get(this.item, 'productionYear'),
        ...countries,
        itemDuration
      ]
        .filter(Boolean) // filter empty values
        .map(item => capitalizeFLetter(item)) // add Maj on all items
        .join(', ')
    }
  }
}
</script>

<style lang="scss" scoped>
.fip-mentions {
  span {
    padding: 0;
    margin: 0 5px 0 0;
    @include mediaQueries('font-size', (xsmall: 16px, large: 12px, xlarge: 14px));
    line-height: 1.38;
    font-weight: bold;
  }
}
</style>
